import { DepositionSummaryActions } from '@app/types/deposition-summary';
import { DocumentType } from '@utils/enums.ts';
import { routes } from '@shared/constants/paths';
import { deleteDocumentInstance } from '@api/document-instance';
import { deleteDepositionSummary } from '@api/deposition-summary';
import { deleteUseCase } from '@api/use-case';

export function buildDepositionSummaryActionsMap(
  navigate: (path: string) => void
): Record<DocumentType, DepositionSummaryActions> {
  return {
    [DocumentType.DEPOSITION_SUMMARY]: {
      onEdit: (id: number) =>
        navigate(routes.myDocuments.depositionSummary.update(id)),
      onView: (id: number) =>
        navigate(routes.myDocuments.depositionSummary.view(id)),
      onDelete: deleteDepositionSummary,
    },
    [DocumentType.DEMAND_LETTER]: {
      onEdit: (id: number) =>
        navigate(routes.myDocuments.demandLetter.update(id)),
      onView: (id: number) =>
        navigate(routes.myDocuments.demandLetter.view(id)),
      onDelete: deleteDocumentInstance,
    },
    [DocumentType.USE_CASE]: {
      onEdit: (id: number) => navigate(routes.myDocuments.useCase.update(id)),
      onView: (id: number) => navigate(routes.myDocuments.useCase.view(id)),
      onDelete: deleteUseCase,
    },
  };
}
